module.exports = __webpack_public_path__ + "img/logo-auth.aace415c.png";